export const isParentApiCollection = (col) => col.type === "ApiCollection" && col?.childs?.length > 1;
